// extracted by mini-css-extract-plugin
export default {"header":"Header_header__OKWO7","container":"Header_container__TsUVY"};